import React from "react";
import CustomModal from "common/components/CustomModal/CustomModal";
import {
	ModalPanel,
	ModalHeader,
	ModalBody,
} from "common/components/CustomModal/Modal/ModalFrame";
import UserManager from "common/userManager";
import FatButton from "common/components/FatButton/FatButton";

export default function AccountRequired() {
	return (
		<CustomModal>
			<ModalPanel>
				<ModalHeader>Account Required</ModalHeader>
				<ModalBody>
					<p>
						To save picks and get rewarded based on global placements{" "}
						<label className="pickstop-color">Login</label> or{" "}
						<label className="pickstop-color">Register</label>
					</p>
					<div style={{ display: "flex", justifyContent: "center" }}>
						<FatButton
							text="Login"
							onClick={() => UserManager.openLoginModal()}
							primary
						/>
						<FatButton
							text="Register"
							onClick={() => UserManager.openRegisterModal()}
							primary
						/>
					</div>
				</ModalBody>
			</ModalPanel>
		</CustomModal>
	);
}
